<template>
	<div class="planning">
		<calendar v-bind:rooms="rooms" v-bind:month="month" v-bind:year="year" v-bind:days="days"
			v-on:change-month="changeMonth" v-on:on-add-day="openModal" />
		<v-dialog v-model="showModal" width="714" scrollable style="height: 584px">
			<v-card class="px-4 modal-maid">
				<div class="close-button" v-on:click="openModal">
					<v-icon dark class="icon-close">close</v-icon>
				</div>
				<p class="modal-title">Asignar Mucama</p>
				<div class="maid-list">
					<user-selector-list v-bind:users="maids" v-on:on-change-selected="onMaidSelected" />
				</div>
				<div class="clean-container">
					<div class="clean-type">
						<p class="modal-title">Tipo de Limpieza:</p>
						<div class="clean-types-list">
							<div v-for="item in cleanTypes" v-bind:key="item.id">
								<input type="radio" hidden name="cleanTypes" v-model="model.cleanTypeSelected"
										v-bind:id="item.id" class="input-clean-type" v-bind:value="item.id" />
								<label v-bind:for="item.id" class="clean-type">
									{{ item.name }}
								</label>
							</div>
						</div>
					</div>
					<div class="body-border-left ml-4 mr-3">
					</div>
					<div class="clean-time">
						<p class="modal-title">Hora:</p>
						<div class="clean-form">
							<div>
								<span class="container-icon-description time-done">
									<span class="sprite-icons time-done"></span>
								</span>
							</div>
							<div>
								<v-select class="time-select" v-bind:items="hours" hide-details v-model="model.hour"></v-select>
							</div>
							<div>
								<v-select class="time-select" v-bind:items="minutes" hide-details v-model="model.minute"></v-select>
							</div>
							<div class="clean-types-list">
								<div>
									<input type="radio" hidden name="tymeClean" v-model="model.modeClock"
											id="am" class="input-clean-type" value="am" />
									<label for="am" class="clean-type" style="max-width: 64px">
										.a.m.
									</label>
								</div>
								<div>
									<input type="radio" hidden name="tymeClean" v-model="model.modeClock"
											id="pm" class="input-clean-type" value="pm" />
									<label for="pm" class="clean-type" style="max-width: 64px">
										.p.m.
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="clean-comment mt-2">
					<p class="modal-title">Comentario o Sugerencia</p>
					<textarea class="comment mt-2" cols="30" rows="10" v-model="model.comment"></textarea>
				</div>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn v-bind:disabled="isValid" v-bind:loading="isLoading" class="assign-btn white--text"
						primary v-on:click.native="assignMaid">Asignar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>

import mixins from '@/shared/mixins';
import UserSelectorList from '@/components/shared/UserSelectorList';
import Calendar from './calendar/Calendar';

const daysNames = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

async function assignMaid() {
	this.isLoading = true;
	this.showModal = false;
	try {
		await this.$http.post('assign-maid', this.model);
		this.showNotification('Mucama asignada correctamente');
		this.loadData();
		this.isLoading = false;
	} catch (error) {
		this.showNotification('Error al asignar mucama', 'error');
		this.isLoading = false;
	}
}

function loadNewRooms() {
	const rooms = [
		{
			id: 1,
			number: '5201',
			type: 'DR',
			maids: [
				{
					id: 1,
					avatar: 'MC',
					dateShort: '10/10/2017',
					firstname: 'Maria',
					lastname: 'Chiappe',
					time: '09:30 a.m.',
					typeCleaning: 'Profunda',
				},
				{
					id: 2,
					avatar: 'LA',
					dateShort: '25/10/2017',
					firstname: 'Luis',
					lastname: 'Advincula',
					time: '10:20 p.m.',
					typeCleaning: 'Profunda',
				},
			],
		},
		{
			id: 2,
			number: '5202',
			type: 'DSQ',
			maids: [
				{
					id: 1,
					avatar: 'RA',
					firstname: 'Renzo',
					lastname: 'Acosta',
					dateShort: '30/10/2017',
					time: '07:20 a.m.',
					typeCleaning: 'Normal',
				},
				{
					id: 2,
					avatar: 'CA',
					firstname: 'Carla',
					lastname: 'Alvarado',
					dateShort: '29/10/2017',
					time: '11:30 a.m.',
					typeCleaning: 'Profunda',
				},
			],
		},
	];
	return rooms;
}

function loadFakeMaids() {
	const maids = [];
	for (let index = 1; index < 9; index += 1) {
		maids.push({ id: (index + 1), name: `Maria ${index}`, lastname: `Chiappe ${index}`, url_image: '//placecage.com/gif/47/47' });
	}
	return maids;
}

function getDayName(dayNumber) {
	return daysNames[dayNumber];
}

function generateDays() {
	const optionDate = { year: 'numeric', month: '2-digit', day: '2-digit' };
	const currentDate = new Date(this.year, this.month - 1, 1);
	const today = new Date();
	const daysValues = [];
	let index = 1;
	while ((currentDate.getMonth() + 1) === this.month) {
		const currentDay = currentDate;
		const dayInfo = {
			date: new Date(currentDay),
			day: currentDay.getDate(),
			dateShort: currentDay.toLocaleDateString('es-PE', optionDate),
			dayName: getDayName(currentDay.getDay()),
			disabled: today > currentDay,
			id: index,
		};
		daysValues.push(dayInfo);
		currentDate.setDate(currentDate.getDate() + 1);
		index += 1;
	}
	this.days = daysValues;
}

function mockupData() {
	this.rooms = this.rooms.map((room) => {
		const newRoom = room;
		newRoom.maids = this.days.map((day) => {
			let newMaid = {};
			const maidExists = room.maids.find(m => m.dateShort === day.dateShort);
			if (!maidExists) {
				newMaid.id = day.id;
				newMaid.avatar = '';
				newMaid.firstname = '';
				newMaid.lastname = '';
				newMaid.dateShort = day.dateShort;
				newMaid.color = '#fff';
				newMaid.disabled = day.disabled;
			} else {
				maidExists.disabled = day.disabled;
				newMaid = maidExists;
			}
			return newMaid;
		});
		return newRoom;
	});
}

function created() {
	this.loadTime();
	this.loadData();
}

function changeMonth(type) {
	if (type === 1) {
		if (this.month === 1) {
			this.month = 12;
			this.year -= 1;
		} else {
			this.month -= 1;
		}
	}
	if (type === 2) {
		if (this.month === 12) {
			this.month = 1;
			this.year += 1;
		} else {
			this.month += 1;
		}
	}
	this.loadData();
}

function isValid() {
	let result = true;
	if (this.model.maid !== null && this.model.cleanTypeSelected !== null) {
		result = false;
	}
	return result;
}

async function loadData() {
	this.cleanTypes = [{ id: 1, name: 'Normal' }, { id: 2, name: 'Profunda' }];
	this.maids = loadFakeMaids();
	this.rooms = loadNewRooms();
	this.generateDays();
	try {
		const response = await this.$http.get(`calendar/${this.month}/${this.year}`);
		this.rooms = response.data;
	} catch (error) {
		this.mockupData();
	}
}

function loadTime() {
	for (let index = 1; index < 13; index += 1) {
		this.hours.push(index < 10 ? `0${index}` : index);
	}
	for (let mIndex = 1; mIndex < 60; mIndex += 1) {
		this.minutes.push(mIndex < 10 ? `0${mIndex}` : mIndex);
	}
}

function data() {
	return {
		cleanTypes: [],
		days: [],
		hours: [],
		isLoading: false,
		minutes: [],
		month: new Date().getMonth() + 1,
		maids: [],
		model: {
			cleanTypeSelected: null,
			comment: '',
			hour: '01',
			minute: '01',
			modeClock: 'am',
			maid: null,
		},
		rooms: [
			{
				id: 1,
				number: '5201',
				type: 'DR',
				maids: [
					{
						id: 1,
						avatar: 'MC',
						dateShort: '10/10/2017',
						firstname: 'Maria',
						lastname: 'Chiappe',
						time: '09:30 a.m.',
						typeCleaning: 'Profunda',
					},
					{
						id: 2,
						avatar: 'LA',
						dateShort: '25/10/2017',
						firstname: 'Luis',
						lastname: 'Advincula',
						time: '10:20 p.m.',
						typeCleaning: 'Profunda',
					},
				],
			},
			{
				id: 2,
				number: '5202',
				type: 'DSQ',
				maids: [
					{
						id: 1,
						avatar: 'RA',
						firstname: 'Renzo',
						lastname: 'Acosta',
						dateShort: '30/10/2017',
						time: '07:20 a.m.',
						typeCleaning: 'Normal',
					},
					{
						id: 2,
						avatar: 'CA',
						firstname: 'Carla',
						lastname: 'Alvarado',
						dateShort: '29/10/2017',
						time: '11:30 a.m.',
						typeCleaning: 'Profunda',
					},
				],
			},
		],
		showModal: false,
		today: new Date(),
		year: new Date().getFullYear(),
	};
}

function onMaidSelected(maid) {
	this.model.maid = maid;
}

function openModal() {
	this.showModal = !this.showModal;
}

export default {
	name: 'planning-housekeeping',
	components: {
		Calendar,
		UserSelectorList,
	},
	computed: {
		isValid,
	},
	created,
	data,
	methods: {
		assignMaid,
		changeMonth,
		generateDays,
		loadData,
		loadTime,
		mockupData,
		onMaidSelected,
		openModal,
	},
	mixins,
};
</script>

<style lang="scss" scoped>
.modal-maid {
	padding: 25px 39px 27px 30px;
	position: relative;
}

.clean-container {
	display: flex;
}

.clean-types-list {
	display: flex;
}

label.clean-type {
	align-items: center;
	background: transparent;
	border: 1px solid map-get($colors, border-radio);
	border-radius: 100px;
	color: map-get($colors, default-button-color);
	cursor: pointer;
	display: inline-flex;
	font-size: map-get($sizes, twelve);
	height: 33px;
	justify-content: center;
	margin: 15px 13px 9px 0px;
	width: 95px;
}

input.input-clean-type:checked + .clean-type {
	background: map-get($colors, radio-input-blue);
	border-color: map-get($colors, radio-input-blue);
	color: white;
}

.modal-title {
	color: map-get($colors, default-dark);
	font-family: map-get($fonts, medium);
  font-size: 14px;
	font-weight: 500;
	margin: 0;
	text-align: left;
}

.clean-input {
	height: 21px;
	width: 21px;
}

.clean-form {
	align-items: center;
	display: flex;
	justify-content: center;

	>* {
		margin-left: 10px;
	}

}

.comment {
	border: solid 1px map-get($colors, e-bg-icon);
	max-height: 111px;
	width: 100%;
}

.time-select {
	height: 22px;
}

.container-icon-description {
	border-radius: 100%;
	display: inline-block;
	font-size: inherit;
	height: 17px;
	text-align: center;
	width: 17px;

	&.time-done {
		background-color: map-get($colors, done-time);
	}
}

.assign-btn {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1) !important;
  background-color: map-get($colors, default-skyblue) !important;
  height: 38px !important;
  width: 113px !important;
}

.close-button {
	background-color: map-get($colors, header-dark);
	border-radius: 50%;
	cursor: pointer;
	height: 15px;
	position: absolute;
	right: 5px;
	top: 5px;
	width: 15px;

	.icon-close {
		font-size: 15px;
		left: 0;
		position: absolute;
	}
}

</style>




// WEBPACK FOOTER //
// Planning.vue?2e49207a